import { render, staticRenderFns } from "./RefractiveDiscrepancyDevice.vue?vue&type=template&id=6ef565cf&scoped=true&"
import script from "./RefractiveDiscrepancyDevice.vue?vue&type=script&lang=js&"
export * from "./RefractiveDiscrepancyDevice.vue?vue&type=script&lang=js&"
import style0 from "./RefractiveDiscrepancyDevice.vue?vue&type=style&index=0&id=6ef565cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef565cf",
  null
  
)

export default component.exports